import React, { useEffect } from 'react';

/**
 * Composant invisible qui capture la prochaine combinaison de touches.
 *
 * Props :
 * - onCapture : (shortcut: { key: string, modifiers: string[] }) => void
 * - onCancel : () => void
 */
const ShortcutCapture = ({ onCapture, onCancel }) => {
  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      e.stopPropagation();

      if (e.key === 'Escape') {
        onCancel();
        return;
      }

      // Ignorer les touches seules qui sont des modificateurs
      const modifierKeys = ['Control', 'Shift', 'Alt', 'Meta', 'CapsLock', 'Tab'];
      if (modifierKeys.includes(e.key)) {
        return;
      }

      const modifiers = [];
      if (e.ctrlKey) modifiers.push('ctrl');
      if (e.metaKey) modifiers.push('cmd');
      if (e.altKey) modifiers.push('alt');
      if (e.shiftKey) modifiers.push('shift');

      let key = e.key.toLowerCase();
      // Alias
      if (key === ' ') key = 'space';
      if (key === 'escape') key = 'esc';
      if (key === 'arrowup') key = 'up';
      if (key === 'arrowdown') key = 'down';
      if (key === 'arrowleft') key = 'left';
      if (key === 'arrowright') key = 'right';

      // Empêcher les combinaisons sans modificateur (sauf pour les touches spéciales comme F1-F12)
      const functionKeys = /^f\d+$/;
      if (modifiers.length === 0 && !functionKeys.test(key)) {
        return;
      }

      onCapture({ key, modifiers });
    };

    document.addEventListener('keydown', handler, true);
    return () => document.removeEventListener('keydown', handler, true);
  }, [onCapture, onCancel]);

  return (
    <div className="sr-only" role="status" aria-live="polite">
      En attente d&apos;une touche...
    </div>
  );
};

export default ShortcutCapture;
